<template>
  <div id="Parlor-3.2.4">
    <div class="parlor-header">
      <BlockChartBarLineBox
        class="parlor-hd-item"
        title="月活跃用户数(万人)"
        :options="activeNumChartData"
        :data="activeNumChart"
        :y-axis-min="1000"
      ></BlockChartBarLineBox>
      <BlockChartBarLineBox
        class="parlor-hd-item"
        title="月日均活跃用户数(万人)"
        :options="activeMonthAvgNumData"
        :data="activeMonthAvgNumChart"
        :y-axis-min="500"
      ></BlockChartBarLineBox>
      <BlockChartBarLineBox
        class="parlor-hd-item"
        title="活跃ARPU值(元)"
        :options="ARPUDData"
        :data="ARPUD"
      ></BlockChartBarLineBox>
      <BlockChartBarLineBox
        class="parlor-hd-item"
        title="月度净额营收(万元)"
        :options="dayIncomeData"
        :data="dayIncome"
      >
        <template v-slot:bot>
          <div class="qeys-wrap">
            <p style="margin-bottom:.5rem" class="qeys-item">
              <span>年度净额营收</span>
              <span class="count">{{ (weekOpen.yearNetIncome||0).toFixed(2) }}</span>
            </p>
            <p class="qeys-item">
              <span>月度全额营收</span>
              <span class="count">{{ (weekOpen.monthIncome||0).toFixed(2) }}</span>
            </p>
          </div>
        </template>
        <template v-slot:blockSubTitle>
          <span class="qeys-title-slot">非实时:{{ (weekOpen.nonrealTimeIncome||0).toFixed(2) }}</span>
        </template>
      </BlockChartBarLineBox>
    </div>
    <div class="parlor-container">
      <el-row :gutter="20">
        <el-col :span="10">
          <div class="container-left " id="ywzb-table">
            <div class="left-top">
              <c-block-box
                title="业务关键指标"
              >
                <table
                  class="table-item"
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                >
                  <thead class="table-head">
                    <tr>
                      <th class="head-item">核心指标</th>
                      <th class="head-item">本月目标</th>
                      <th class="head-item">当前值</th>
                      <th class="head-item">环比</th>
                      <th class="head-item">同比</th>
                      <th class="head-item">目标完成率</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <div class="vacancy"></div>
                    <!-- <tr class="table-line" v-for="(item, index) in dig.closeRateData" :key="index"> -->
                    <tr class="table-line" v-for="(item, index) in livingRoomIndicators" :key="index">
                      <td class="body-lable">{{ item.name }}</td>
                      <td class="body-lable">{{ item.target }}</td>
                      <td class="body-lable">{{ item.current }}</td>
                      <td class="body-lable">
                        <c-progress
                          class="c-progress"
                          height="1.1rem"
                          :num="(item.hbRatio||0).toFixed(2)"
                        ></c-progress>
                      </td>
                      <td class="body-lable">{{ item.tbRatio }}%</td>
                      <td class="body-lable">{{ item.finishRatio }}%</td>
                    </tr>
                  </tbody>
                </table>
              </c-block-box>
            </div>
            <div class="left-bot">
              <c-block-box
                title="业务线营收占比"
              >
                <!-- <ChartPie id="ywxzb" :option="ChartPieOption" height="30rem"></ChartPie> -->
                <div id="ywxzb" style="height:13.7rem"></div>
              </c-block-box>
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="container-right no-padding-right-even">
            <el-col :span="12">
              <c-block-box title="付费率">
                <ChartBarLine
                  id="as1"
                  height="12.7rem"
                  :option="RateOption"
                ></ChartBarLine>
              </c-block-box>
            </el-col>
            <el-col :span="12">
              <c-block-box title="新增用户7日留存率">
                <ChartBarLine
                  id="as2"
                  height="12.7rem"
                  :option="SevenDayRetentionOption"
                ></ChartBarLine>
              </c-block-box>
            </el-col>
            <el-col :span="12" class="marginblock-box">
              <c-block-box title="周活跃频次">
                <ChartBarLine
                  id="as3"
                  height="12.7rem"
                  :option="WeeklyActiveFrequencyOption"
                ></ChartBarLine>
              </c-block-box>
            </el-col>
            <el-col :span="12" class="marginblock-box">
              <c-block-box title="主页用户活跃粘性">
                <ChartBarLine
                  id="as4"
                  height="12.7rem"
                  :option="HomePageActiveFrequencyOption"
                ></ChartBarLine>
              </c-block-box>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import BlockChartBarLineBox from '@/components/BlockChartBarLineBox/BlockChartBarLineBox'
import ChartPie from '@/components/echarts/pie'
import * as echarts from 'echarts'
import ChartBarLine from '@/components/echarts/line2'
import common from '@/mixins/common.js'
import { initIncomePercentPie, lineFormatDataSecond } from './js/Parlor-3.2.4.js'
export default {
  mixins: [common],
  name: 'Parlor324',
  components: {
    BlockChartBarLineBox,
    ChartPie,
    ChartBarLine
  },
  props: {},
  data () {
    return {
      weekOpen: {},
      parlorData: {
        weekOpen: {},
        businessIndicators: [],
        nps: {},
        projects: []
      },
      ChartPieOption: {},
      ChartBarLineData: {
        config: {}
      },
      activeNumChart: {}, // 月活跃用户数(万人)
      activeNumChartData: {},
      activeMonthAvgNumChart: {}, // 月日均活跃用户数(万人)
      activeMonthAvgNumData: {},
      dayIncome: {}, // 月度实时净额营收(万元)
      dayIncomeData: {},
      ywzxPieChart: null,
      ARPUD: {}, //
      ARPUDData: {},
      RateOption: {}, // 付费率
      SevenDayRetentionOption: {}, // 七日留存率
      WeeklyActiveFrequencyOption: {}, // 周活跃频次
      HomePageActiveFrequencyOption: {}, // 主页活跃频次
      livingRoomIndicators: []// 业务指标数据
    }
  },
  computed: {

  },
  created () {
    this.getProject()
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    getProject () {
      const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
      this.$service.fetch({
        url: 'api/livingRoom/dashboard_v2',
        params: {
          month: choiceDate.time
        }
      }).then(res => {
        this.parlorData = res.weekOpenChart
        this.weekOpen = res.weekOpen
        this.lineFormatData(this.parlorData, ['%'])
        this.activeNumChart = res.activeNumChart
        this.activeNumChart.yAxis = { name: '万' }// 月活跃用户数(万人)
        this.activeMonthAvgNumChart = res.activeMonthAvgNumChart
        this.activeMonthAvgNumChart.yAxis = { name: '万' }// 月日均活跃用户数(万人)

        this.dayIncome = res.dayIncome
        this.dayIncome.yAxis = { name: '万' }// 月度实时净额营收(万元)
        this.ARPUD = res.monthArpuChart
        this.ChartPieOption = initIncomePercentPie({ res: res.incomePercent, vue: this })
        this.setPieChart()

        let { netMonthFinishRatio, monthYRatio, activeNumCompare, avtiveNumMonthAvgCompare, avtiveNumMonthAvgYRate, avtiveNumMonthAvgTargetRate, avtiveNumMonthAvgTarget, avtiveNumMonthAvg, monthNetIncome, monthNetRatio, monthTarget, monthFinishRatio, arpu, arpuYRate, arpuCompare, arpuTarget, arpuTargetRate, activeRate, activeRateCompare, activeRateTarget, activeRateTargetRate, rateCompare, activeNumYRate, activeNum, activeNumTargetRate, activeNumTarget, activeNumRate } = res.weekOpen
        this.dayIncomeData = {
          activeRate: Math.round(monthNetIncome),
          rateCompare: monthNetRatio,
          activeRateCompare: monthYRatio,
          activeRateTarget: monthTarget,
          activeRateTargetRate: netMonthFinishRatio
        }
        // 月活跃
        this.activeNumChartData = {
          activeRate: Math.round(this.splitWnumber(activeNum)),
          activeRateCompare: activeNumCompare,
          activeRateTarget: activeNumTarget / 10000,
          activeRateTargetRate: activeNumTargetRate,
          rateCompare: activeNumYRate
        }
        // 月日均活跃用户数
        this.activeMonthAvgNumData = {
          activeRate: Math.round(this.splitWnumber(avtiveNumMonthAvg)), // 值
          activeRateCompare: avtiveNumMonthAvgCompare, // 同比
          activeRateTarget: avtiveNumMonthAvgTarget, // 目标
          activeRateTargetRate: (avtiveNumMonthAvgTargetRate / 10000).toFixed(4), // 完成率
          rateCompare: avtiveNumMonthAvgYRate// 环比

        }
        this.ARPUDData = {
          activeRate: arpu.toFixed(2),
          rateCompare: arpuYRate,
          activeRateCompare: arpuCompare,
          activeRateTarget: arpuTarget,
          activeRateTargetRate: arpuTargetRate
        }
        this.livingRoomIndicators = res.livingRoomIndicators// 业务指标数据

        // 付费率
        this.RateOption = lineFormatDataSecond({ data: res.payRateChart, yKey: ['%'], vue: this })
        // this.RateOption.config.title.text = '付费率'
        // 新增用户7日留存率
        this.SevenDayRetentionOption = lineFormatDataSecond({ data: res.retentionRateChart, yKey: ['%'], vue: this, yAxisMin: 30 })
        // this.SevenDayRetentionOption.config.title.text = '新增用户7日留存率'
        // 周活跃频次
        this.WeeklyActiveFrequencyOption = lineFormatDataSecond({ data: res.weekActiveFrequencyChart, yKey: ['天'], yAxisMin: 3.5, vue: this })
        this.WeeklyActiveFrequencyOption.data.forEach(item => {
          item.step = 'start'
          item.smooth = false
        })
        this.WeeklyActiveFrequencyOption.config.xAxis.push(
          {
            type: 'category',
            data: this.WeeklyActiveFrequencyOption.config.xData,
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)'
              }
            }
          }
        )
        this.WeeklyActiveFrequencyOption.config.yAxis[0].interval = 0.5
        this.WeeklyActiveFrequencyOption.config.yAxis[0].splitNumber = 3
        if (this.WeeklyActiveFrequencyOption.config.xData[0]) {
          let valDay = this.$dayjs(this.WeeklyActiveFrequencyOption.config.xData[0]).subtract(6, 'day').format('MM-DD')
          this.WeeklyActiveFrequencyOption.config.xAxis[0].data.unshift(valDay)
          this.WeeklyActiveFrequencyOption.data.forEach(item => {
            item.data.unshift(item.data[0])
          })
        }
        // this.WeeklyActiveFrequencyOption.config.title.text = '周活跃频次'
        // 主页活跃频次
        this.HomePageActiveFrequencyOption = lineFormatDataSecond({ data: res.homepageActiveFrequencyChart, yKey: ['%'], vue: this, yAxisMin: 40 })
        // this.HomePageActiveFrequencyOption.config.title.text = '主页活跃频次'
      })
    },

    setPieChart () {
      this.$nextTick(() => {
        var chartDom = document.getElementById('ywxzb')
        this.ywzxPieChart = echarts.init(chartDom, {}, { renderer: 'svg' })
        this.ywzxPieChart && this.ywzxPieChart.setOption(this.ChartPieOption)
      })
    },
    lineFormatData (data, yKey, type) {
      const isAndroid = this.$store.state.app.isAndroid
      const keys = Object.keys(data)
      let minValueArr = []
      keys.forEach((item) => {
        minValueArr.push(this.mathMin(data[item].data))
      })
      const minValue = this.mathMin(minValueArr)
      let xData = []
      if (data[keys[0]] && data[keys[0]].data) {
        xData = data[keys[0]].date.map(item => {
          return this.$cUtils.format.formatDate(item, 'MM-dd')
        })
      }
      const option = {
        config: {
          color: false,
          title: {
            // text: 'Referer of a Website'
          },
          xData: xData,
          splitNumber: 2,
          legend: {
            top: !isAndroid ? 20 : 10,
            right: 10
          },
          grid: {
            top: 45,
            right: 10,
            bottom: 10
          },
          yAxis: []
        },
        data: []
      }
      const yAxis = {
        name: yKey[0],
        type: 'value',
        splitLine: {
          lineStyle: {
            color: 'rgba(255,255,255,0.1)'
          }
        },
        min: minValue,
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: 'rgba(255,255,255,.6)',
            fontSize: !isAndroid ? 12 : 10
          }
        },
        nameTextStyle: {
          color: '#999',
          fontSize: !isAndroid ? 12 : 10
        },
        splitNumber: 1
      }
      option.config.yAxis.push(yAxis)
      if (yKey.length > 1 && !!yKey[1]) {
        const copyYAxis = JSON.parse(JSON.stringify(yAxis))
        this.$set(copyYAxis, 'name', yKey[1])
        option.config.yAxis.push(copyYAxis)
      }
      keys.forEach(item => {
        const itemData = {
          name: item,
          data: data[item].data,
          symbol: 'none',
          lineStyle: {
            type: item === '目标' ? 'dashed' : 'solid',
            width: !isAndroid ? 2 : 0.5
          },
          yAxisIndex: item === '活跃率' ? 1 : 0
        }
        if (type && item !== '目标') {
          this.$set(itemData, 'areaStyle', {})
          this.$set(itemData, 'stack', '总量')
        }
        option.data.push(itemData)
      })
      // this.ChartBarLineData = option
      return option
    },
    destoryedChart (dom) {
      if (!dom) {
        return
      }
      dom.dispose()
      dom = null
    }
  },
  beforeDestroy () {
    this.destoryedChart(this.ywzxPieChart)
  }
}
</script>

<style scoped lang="stylus">
.parlor-header
  display flex
  .parlor-hd-item
   display inline-block
   width 24.2%
  .parlor-hd-item+.parlor-hd-item
    margin-left: 1rem
.container-right
  //background-color: #1c1839
  border-radius: .5rem
  overflow hidden
  //height: 37rem
  //padding: 1rem 1rem 0 1rem
  .el-col
    margin-bottom: 1rem

.no-padding-right-even
  > .el-col:nth-of-type(even)
     padding-right 0 !important
  > .el-col:nth-of-type(odd)
     padding-left 0 !important
.container-left .left-top
  margin-bottom: 1rem

.table-item
  padding .6rem 1rem
  vertical-align middle !important
  .table-head
    overflow hidden
    .head-item
      height 1.2rem
      line-height 1.2rem
      background-image linear-gradient(to right, #005EFF, #1896FF)
      color #ffffff
      font-size .7rem
      text-align center
      border-right 2px solid #1c1839
  .head-item:last-child
    border-right 0
    border-radius 0 .3rem .3rem 0
  .head-item:first-child
    margin-left 0
    border-radius .3rem 0 0 .3rem
  .table-body
    .table-line
      text-align center
      line-height 1.2rem
      color rgba(255, 255, 255, .6)
      font-size .7rem
      .body-lable
        overflow hidden
        background #1F1E44
        border-right 2px solid #1c1839
        position relative
        white-space nowrap
      .body-lable:after
        height 1px
        border-bottom 1px solid rgba(255, 255, 255, .1)
        position absolute
        left 0
        bottom 0
        width 100%
        content ''
    .table-line:last-child .body-lable:after
      display none
    .body-lable:last-child
      border-right 0
    .vacancy
      height 5px
      overflow hidden
.border-none:after
  display none
>>>.unit-box--custom
  .unit-header__icon
    right 5.2rem
  .unit-header .title-slot
    float right
    display inline-block
    // padding-right 3rem
.table-body
  padding .5rem 1rem

.container-right
  .marginblock-box
    margin-bottom: 0
  >>>
    .unit-body
      padding .5rem .5rem
      //border-radius: .5rem

#ywzb-table
  .table-line
    line-height: 2.05rem

.qeys-wrap
  font-size:.8rem;
  margin-top:.5rem
  .qeys-item
    color rgba(255,255,255,0.8)
    .count
      margin-top .2rem
      color white
      display block

 .qeys-title-slot
    background rgba(24,150,255, .4)
    color rgba(255,255,255,.8)
    border 1px solid rgba(24,150,255, .6)
    font-size .7rem
    line-height 1.2rem
    padding 0 .5rem
    border-radius .3rem
    margin-left: .3rem
    display inline-block
</style>
